import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AssetTableItem } from "../../../types/types";
import { getTypeConfig } from "./typeConfig";
import Tooltip from "../../../components/ui/Tooltip";

export interface AssetReferenceChipProps {
  assetId: number;
  displayName: string;
  allAssets: AssetTableItem[];
  onNavigate: (_id: number) => void;
}

const AssetReferenceChip: React.FC<AssetReferenceChipProps> = ({
  assetId,
  displayName,
  allAssets,
  onNavigate,
}) => {
  const asset = allAssets.find((a) => a.id === assetId);

  if (!asset) {
    return (
      <span className="inline-flex items-center gap-1 text-zinc-500 line-through text-xs mx-0.5">
        <FontAwesomeIcon icon={faTriangleExclamation} className="text-amber-500 text-[10px]" />
        {displayName}
      </span>
    );
  }

  const cfg = getTypeConfig(asset.type);
  const summary = asset.description
    ? asset.description.slice(0, 80) + (asset.description.length > 80 ? "…" : "")
    : "";

  const tooltipContent = (
    <div className="max-w-xs p-2 space-y-1">
      <div className="font-semibold text-sm text-white">{asset.name}</div>
      <div className="text-xs">
        <span className={cfg.color}>{cfg.label}</span>
        {asset.category && (
          <>
            <span className="text-zinc-600 mx-1">·</span>
            <span className="text-zinc-400">{asset.category}</span>
          </>
        )}
      </div>
      {summary && <div className="text-xs text-zinc-400 leading-relaxed">{summary}</div>}
    </div>
  );

  return (
    <Tooltip content={tooltipContent} position="top" delay={300}>
      <button
        type="button"
        onClick={() => onNavigate(assetId)}
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-400/15 text-amber-300 border border-amber-400/30 text-xs hover:bg-amber-400/25 transition-colors cursor-pointer mx-0.5"
      >
        <FontAwesomeIcon icon={faLink} className="text-[9px]" />
        {displayName}
      </button>
    </Tooltip>
  );
};

export default AssetReferenceChip;
